(function($g, createjs, M) {

    var Shape = createjs.Shape;
    var Container = createjs.Container;
    var Tween = createjs.Tween;

    function Conclusion(stage, img, duration, text, hommage) {
        var me = this;
        var data = {
          "texteFin" : text.ending,
          "nom" : hommage.firstName||"",
          "nomprenom" : hommage.firstName + " " + hommage.lastName,
          "date" : (hommage.born&&hommage.died) ? (hommage.born.year + " / " + hommage.died.year) : "",
        };
        var timeline;
        var intro = new Container();

        // IMAGE DE BACKGROUND
        var background = new createjs.Bitmap(img);
        //background.alpha = 0;
        intro.addChild(background);

        var elmSubFin = new Container();

        var elmTexteFin = new createjs.Text(data.texteFin.toUpperCase(), "10px avenir-light", "#000000");
        elmTexteFin.x = 0;
        elmTexteFin.y = 0;
        elmTexteFin.textBaseline = "alphabetic";
        elmTexteFin.alpha = 1;
        elmTexteFin.textAlign = "center";
        elmSubFin.addChild(elmTexteFin);

        var elmNomFin = new createjs.Text(data.nom.toUpperCase(), "20px avenir-light", "#000000");
        elmNomFin.x = 0;
        elmNomFin.y = 20;
        elmNomFin.textBaseline = "alphabetic";
        elmNomFin.alpha = 1;
        elmNomFin.textAlign = "center";
        elmSubFin.addChild(elmNomFin);

        //elmSubFin.alpha = 0;
        intro.addChild(elmSubFin);

        // Drawable zone
        var table = new Shape();
        intro.addChild(table);

        function appear(parent) {
            parent.addChild(intro);
            updateSize();
        }
        function clear() {
            var p = intro.parent;
            if (p) {
                p.removeChild(intro);
            }
        }
        function updateSize() {
            change();
        }

        function change() {
            var ww = stage.canvas.width;
            var hh = stage.canvas.height;
            var b = background.getBounds();
            var iwidth = b.width;
            var iheight = b.height;
            var wr = ww / iwidth;
            var hr = hh / iheight;
            var r = M.max(wr, hr);
            var cx = ww*0.5;
            var cy = hh*0.5;
            var endP = (timeline.position||0) / duration;

            // ON CREER UN MOUVEMENT SUR LE BACKGROUND.
            //background.alpha = 1;
            var scaler = r + 0.8 - endP * 0.5;
            var w = iwidth*scaler;
            var h = iheight*scaler;

            background.scaleX = scaler;
            background.scaleY = scaler;
            background.x = cx - w/2;
            background.y = cy - h/2;

            //var div = 0.1;
            //var wr = ww / bw;
            //var hr = hh / bh;
            //var trans = 1;
            //var rn = M.min(wr, hr)*0.5*trans;

            // ON GÈRE L'AFFICHAGE DE LA FIN
            //elmSubFin.alpha = 0;
            var nameFinb = elmSubFin.getBounds();
            var bh = nameFinb.height;
            var bw = nameFinb.width;
            var wr = ww / bw;
            var hr = hh / bh;
            var trans = 2-(endP*2);
            if (trans < 1){ trans = 1; }
            var rn = M.min(wr, hr)*0.5*trans;

            //intro.alpha = Math.min(1,1-((div - endP)/div));

            //elmSubFin.alpha = Math.min(1,1-((div - endP)/div));
            elmSubFin.scaleX = rn;
            elmSubFin.scaleY = rn;
            elmSubFin.x = cx;
            elmSubFin.y = cy;
        };

        this.show = appear;
        this.hide = clear;
        this.resize = updateSize;
        this.ready = true;

        var init = function() {
            timeline = Tween.get(intro, {paused: true, onChange: change});
            timeline
                    .wait(duration);
            me.timeline = timeline;
        };

        init();
    }

    $g.Conclusion = Conclusion;

})(PVPGEngine, createjs, Math);
